/* ============
 * Home Index Page
 * ============
 *
 * The home index page
 */

export default {
  components: {
    VLayout: require('@/layouts/default/default.vue'),
    VPanel: require('@/components/panel/panel.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/pages/home/index/index.js